
import { getWorkspace } from "../Model/Workspace"
import { useState, useEffect } from "react"
import { workspaceEvents } from "../db/workspaceEvents"
const SubscriptionHelper = () => {
    const [workspace, setWorkspace] = useState(null)
    useEffect(() => {
            async function loadWorkspace() {
                const data = await getWorkspace()
                setWorkspace(data)
            }
            loadWorkspace();
    
            const handleWorkspaceChange = () => {
                loadWorkspace();
            };
    
            workspaceEvents.addEventListener("workspaceChange", handleWorkspaceChange);
    
            return () => {
                workspaceEvents.removeEventListener("workspaceChange", handleWorkspaceChange);
            };
        }, [])

    const subscription = workspace?.subscription;
    const isTester = workspace?.freeTester;

    function isAllowed(target) {
        return isTester || (subscription && subscription[target])
    }

    function hasActive(target) {
        return workspace ? workspace[target] : false
    }

    function getValue(target) {
        return workspace ? workspace[target] : null
    }

    return { isAllowed, hasActive, getValue }
}
export default SubscriptionHelper